import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
import { set } from '@/lib/service/storage';
var m = {
  namespaced: true,
  state: function state() {
    return {
      bgInfo: [],
      wishInfo: [],
      cardUrl: '',
      selectedWishList: []
    };
  },
  getters: {},
  mutations: {
    /** 设置背景信息 */
    setBgInfo: function setBgInfo(state, bgInfo) {
      state.bgInfo = bgInfo;
    },

    /** 设置心愿信息 */
    setWishInfo: function setWishInfo(state, wishInfo) {
      state.wishInfo = wishInfo;
    },

    /** 设置生成的心愿卡的url */
    setCardUrl: function setCardUrl(state, url) {
      state.cardUrl = url;
      set('wishCardUrl', url);
    },

    /** 设置选好的心愿列表 */
    setSelectedWishList: function setSelectedWishList(state, selectedWishList) {
      state.selectedWishList = selectedWishList;
      set('selectedWishList', JSON.stringify(selectedWishList));
    }
  },
  actions: {
    /**
     * 获取预设的心愿信息
     */
    getWishInfo: function getWishInfo(_a) {
      var commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/wish_list/presets')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setWishInfo', rdata.data.wishes);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取预设的背景信息
     */
    getBgInfo: function getBgInfo(_a) {
      var commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/wish_list/presets')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setBgInfo', rdata.data.backgrounds);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取生成的卡片的链接
     */
    getCardUrl: function getCardUrl(_a, _b) {
      var commit = _a.commit;
      var backgroundId = _b.backgroundId,
          wishes = _b.wishes;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/wish_list/generate_card', {
                background_id: backgroundId,
                wishes: wishes
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setCardUrl', rdata.data.url);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;